import { FaLightbulb, FaUsers, FaLeaf, FaHeart, FaShieldAlt, FaHandshake, FaRocket } from 'react-icons/fa';

// Core Values Component

export default function CoreValues() {
  const allValues = [
    {
      title: "Innovation",
      description: "We embrace technology to transform challenges into opportunities.",
      icon: FaLightbulb,
      number: "01"
    },
    {
      title: "Inclusivity",
      description: "We design solutions that serve everyone, leaving no one behind.",
      icon: FaUsers,
      number: "02"
    },
    {
      title: "Sustainability",
      description: "We prioritize long-term, responsible, and eco-conscious innovations.",
      icon: FaLeaf,
      number: "03"
    },
    {
      title: "Humility",
      description: "We serve with respect, empathy, and a people-first mindset.",
      icon: FaHeart,
      number: "04"
    },
    {
      title: "Responsibility",
      description: "We are accountable to society, our clients, and future generations.",
      icon: FaShieldAlt,
      number: "05"
    },
    {
      title: "Trustworthiness",
      description: "We build lasting relationships by being reliable and transparent.",
      icon: FaHandshake,
      number: "06"
    },
    {
      title: "Impact",
      description: "We focus on creating practical solutions that deliver real, measurable change.",
      icon: FaRocket,
      number: "07"
    }
  ];

  return (
    <section className='py-20 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 relative overflow-hidden'>
      {/* Background Pattern */}
      <div className='absolute inset-0'>
        {/* Circuit-like pattern */}
        <div className='absolute inset-0'>
          <svg className='w-full h-full opacity-8' viewBox='0 0 200 200'>
            <defs>
              <pattern id='circuit' x='0' y='0' width='40' height='40' patternUnits='userSpaceOnUse'>
                <rect x='0' y='0' width='40' height='40' fill='none'/>
                <circle cx='10' cy='10' r='1' fill='currentColor' className='text-green-300'/>
                <circle cx='30' cy='30' r='1' fill='currentColor' className='text-emerald-300'/>
                <path d='M10,10 L30,10 L30,30' stroke='currentColor' strokeWidth='0.5' fill='none' className='text-green-300'/>
                <path d='M10,30 L30,30 L30,10' stroke='currentColor' strokeWidth='0.3' fill='none' className='text-emerald-300'/>
              </pattern>
            </defs>
            <rect width='100%' height='100%' fill='url(#circuit)'/>
          </svg>
        </div>
        
        {/* Floating numbered elements */}
        <div className='absolute top-16 right-16 w-12 h-12 bg-green-100/60 rounded-full flex items-center justify-center text-green-600 font-bold text-sm animate-pulse'>01</div>
        <div className='absolute bottom-24 left-20 w-10 h-10 bg-emerald-100/50 rounded-full flex items-center justify-center text-emerald-600 font-bold text-xs animate-pulse animation-delay-400'>07</div>
        <div className='absolute top-1/3 right-1/4 w-8 h-8 bg-teal-100/40 rounded-full flex items-center justify-center text-teal-600 font-bold text-xs animate-pulse animation-delay-700'>03</div>
        
        {/* Connecting lines */}
        <div className='absolute inset-0'>
          <svg className='w-full h-full opacity-15' viewBox='0 0 100 100'>
            <path d='M20,20 Q40,10 60,20 T100,30' stroke='currentColor' strokeWidth='1' fill='none' className='text-green-400' strokeDasharray='2,2'>
              <animate attributeName='stroke-dashoffset' dur='6s' repeatCount='indefinite' values='0;4;0'/>
            </path>
            <path d='M0,70 Q30,60 60,70 T100,80' stroke='currentColor' strokeWidth='1' fill='none' className='text-emerald-400' strokeDasharray='3,1'>
              <animate attributeName='stroke-dashoffset' dur='8s' repeatCount='indefinite' values='0;4;0'/>
            </path>
          </svg>
        </div>
      </div>
      
      <div className='container mx-auto px-6 relative z-10'>
        <div className='max-w-6xl mx-auto'>
          <div className='text-center mb-16'>
            <h2 className='text-4xl md:text-5xl font-bold text-gray-900 mb-8 font-comfortaa'>
              Our <span className='text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600'>Core Values</span>
            </h2>
            <div className='w-24 h-1 bg-gradient-to-r from-green-500 to-emerald-600 mx-auto rounded-full mb-8'></div>
            <p className='text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto'>
              Seven fundamental principles that guide everything we do and shape our commitment to society.
            </p>
          </div>
          
          {/* All Values - Consistent Card Design */}
          <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
            {allValues.map((value, index) => (
              <div key={index} className='bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-green-100 hover:border-green-300 group'>
                <div className='flex items-start gap-6'>
                  <div className='flex-shrink-0'>
                    <div className='w-16 h-16 rounded-2xl bg-gradient-to-r from-green-500 to-emerald-600 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-300'>
                      <value.icon className='text-white text-xl' />
                    </div>
                    <div className='text-3xl font-bold text-green-200 font-comfortaa text-center'>{value.number}</div>
                  </div>
                  <div className='flex-1'>
                    <h3 className='text-2xl font-bold text-gray-900 mb-3 font-comfortaa'>{value.title}</h3>
                    <p className='text-gray-600 leading-relaxed'>{value.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

